export const formatCurrency = (amount, currency = "NGN", locale) => {
  if (!amount) return currency === "USD" ? "$0" : "₦0";

  if (!locale) {
    locale = currency === "USD" ? "en-US" : "en-NG";
  }

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
  }).format(amount);
};

export const getCurrencySymbol = (currency) => {
  switch (currency) {
    case "USD":
      return "$";
    case "NGN":
      return "₦";
    default:
      return currency;
  }
};


export const formatDate = (date) => {
  if (!date) return null;

  let parsedDate;

  if (typeof date === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
    const [day, month, year] = date.split("/");
    parsedDate = new Date(year, month - 1, day);
  } else {
    parsedDate = new Date(date);
  }

  if (isNaN(parsedDate)) return "N/A";

  const day = parsedDate.getDate().toString().padStart(2, "0");
  const month = parsedDate
    .toLocaleString("default", { month: "short" })
    .toUpperCase();
  const year = parsedDate.getFullYear();

  return `${day} ${month}, ${year}`;
};

export const formatDateWithOrdinal = (date) => {
  if (!date) return "N/A";

  let parsedDate;

  if (date instanceof Date) {
    parsedDate = date;
  } else if (typeof date === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
    const [day, month, year] = date.split("/");
    parsedDate = new Date(`${year}-${month}-${day}`);
  } else {
    parsedDate = new Date(date);
  }

  if (isNaN(parsedDate)) return "N/A";

  const day = parsedDate.getDate();
  const month = parsedDate.toLocaleString("default", { month: "short" });
  const year = parsedDate.getFullYear();

  const ordinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return `${ordinal(day)} ${month}, ${year}`;
};


export const getEventStatus = (eventDate) => {
  if (!eventDate) return "Unknown";

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const eventDay = new Date(eventDate);
  eventDay.setHours(0, 0, 0, 0);

  const diffTime = eventDay.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return "Completed";
  if (diffDays === 0) return "Active";
  return "Upcoming";
};

export const formatDateTime = (date) => {
  if (!date) return null;

  let parsedDate;

  // handle dd/mm/yyyy input
  if (typeof date === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
    const [day, month, year] = date.split("/");
    parsedDate = new Date(year, month - 1, day);
  } else {
    parsedDate = new Date(date);
  }

  if (isNaN(parsedDate)) return "N/A";

  const day = parsedDate.getDate().toString().padStart(2, "0");

  const month = parsedDate
    .toLocaleString("en-GB", { month: "short" })
    .toUpperCase();

  const year = parsedDate.getFullYear();

  const time = parsedDate.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${day} ${month}, ${year} • ${time}`;
};